import DBEngine from '@/database/_Base';
import SyncEngine from '@/database/_Sync';

const tableName = 'customerStore';

const functions = {
    async get() {
        await this.sync();

        return await DBEngine.getContentList(tableName);
    },
    async sync() {
        // Sync Data with Server
        await SyncEngine.syncDataVersion(tableName);
    },
    async getDetail(key) {
        const currentData = await this.get();
        
        return await DBEngine.getContentDetailByKey(currentData, key);
    },
    async getDetailByTaxId(taxId) {
        const currentData = await this.get();

        if (currentData.content && currentData.content.length > 0) {
            return currentData.content.find(x => x.taxId === taxId);
        }

        return null
    },
    async save(value) {
        const currentData = await this.get();

        await DBEngine.updateListData(tableName, currentData, value, (value.key ? DBEngine.syncAction().update : DBEngine.syncAction().add));
    },
    async saveCustomerStoreData(taxId, name, contactPerson, contactTel, address, subDistrict, district, province, postCode) {
        const customerStoreData = await this.getDetailByTaxId(taxId);

        const saveData = {
            key: customerStoreData ? customerStoreData.key : '',
            taxId: taxId ? taxId : '',
            name: name ? name : '',
            contactPerson: contactPerson ? contactPerson : '',
            contactTel: contactTel ? contactTel : '',
            address: address ? address : '',
            subDistrict: subDistrict ? subDistrict : '',
            district: district ? district : '',
            province: province ? province : '',
            postCode: postCode ? postCode : ''
        };

        await this.save(saveData);
    }
}

export default functions;